import React, { useEffect, useState } from "react";
import Wrapper from '../../../common/component/Wrapper';
import {
    FormActionComponent,
    HeaderListComponent,
    LoadingComponent,
    PageListComponent,
    FormWrapperItem,
    FormWrapperInputComponent,
    DatePickerComponent
} from '../../../common/component/Index';
import DEFINE,
{
    DETAIL_ACTIONS,
    AUTOFILL_ENUM,
    DATE_TIME_FORMAT,
    PATHS,
    PROMOTION
} from '../../../../../constants/Define';
import {
    capitalizeFirstLetter,
    formatValidation,
    checkUndefine,
    getPermissionActions,
    multipleValidate,
    vietnameseStringToUnicode
} from '../../../../../helpers/functions';
import { withTranslation } from 'react-i18next';
import AntSelect, { AntOption } from "../../../common/component/AntSelect";
import Span from "../../../common/component/Span";
import Input from '../../../common/component/Input';
import Switch from '../../../common/component/Switch';
import { Tooltip, Checkbox, Icon } from 'antd';
import AutoFill, { getAutoFillPlatformKey, normalizeAutoFillPlatforms } from '../../../../../models/AutoFill';
import classNames from 'classnames';
import { cloneDeep, get, toArray } from 'lodash';
import moment from 'moment';
import './AutoFillDetail.less';

const CheckboxGroup = Checkbox.Group
let permissionActions = [];
const AutoFillDetail = ({ ...props }) =>{
    const {
        match,
        t,
        promotionState,
        getAllCampaignsFilter,
        getListPromotions,
        createAutoFill,
        getAutoFillDetails,
        updateAutoFill
    } = props;

    const {
        campaigns,
        isFetchingCampaign,
        promotions,
        isFetching,
        autoFillDetail,
        isFetchingAutoFill
    } = promotionState;

    const [validation, setValidation] = useState({});
    const [action, setAction] = useState(DETAIL_ACTIONS.CREATE);
    const [createType] = useState(null);
    const [isGetItem] = useState(false);
    const [isSubmit] = useState(false);
    const [campaignsValue, setCampaignsValue] = useState([]);
    const [campaign, setCampaign] = useState({});
    const [promotionsValue, setPromotionsValue] = useState([]);
    const [autoFill, setAutoFill] = useState(new AutoFill());
    const [allowCreateAutoFill, setAllowCreateAutoFill] = useState(false);
    const [autoFillApplyConfig, setAutoFillApplyConfig] = useState({});
    const [listAutoFill, setListAutoFill] = useState([]);

    useEffect(()=>{
        function loadData(){
            permissionActions = getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.AUTO_FILL);
            loadDataInit();
            initDetail();
        }
        loadData();
    }, []);

    useEffect(() => {
        try {
            if (campaigns && campaigns.length > 0) {
                setCampaignsValue(campaigns);
            }
            if (promotions) {
                setPromotionsValue(promotions);
            }
        } catch (error) {

        }
    }, [campaigns, promotions]);

    useEffect(()=>{
        if (autoFillDetail && autoFillDetail.campaignId && action === DETAIL_ACTIONS.UPDATE) {
            loadDataPromotion({campaignId: autoFillDetail.campaignId});
            if(autoFillDetail.dayOfWeek){
                setAutoFillApplyConfig(autoFillDetail.dayOfWeek);
            }
            setAutoFill({
                ...autoFill,
                ...autoFillDetail,
                startDate: moment(autoFillDetail?.startDate),
                endDate: moment(autoFillDetail?.endDate)
            });
            setAllowCreateAutoFill(true);
        }
    }, [autoFillDetail]);

    const initDetail = ()=> {
        if (Object.keys(match.params).length > 0) {
            if (!!match.params.id) {
                setAction(DETAIL_ACTIONS.UPDATE);
                getAutoFillDetails(match.params.id);
            }
        }
    }

    const loadDataInit = ()=>{
        getAllCampaignsFilter({
            promotionType: 2,
            hasAutofill: false
        });
    }

    const loadDataPromotion = (dataSearch)=>{
        getListPromotions({...dataSearch});
    }

    function getTitleHeader() {
        return (action === DETAIL_ACTIONS.CREATE
            ? capitalizeFirstLetter((`${ t('action.create') } ${ t('item.autoFill.title') }`).toLowerCase())
            : capitalizeFirstLetter((`${ t('action.update') } ${ t('item.autoFill.title') }`.toLowerCase())))
            + (createType?.label ? ` ${ createType?.label }` : '')
    }

    const validate = ()=> {
        let validate = {
            required: {
                campaignId: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.campaignId`)),
                promotionCodeId: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.promotionCode`)),
                order: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.order`)),
                startDate: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.schedules`)),
                autoFillApplyConfig: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.autoFillApplyConfig`)),
            },
            minLength: {
                memberShipTypes: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.memberShipTypeCheckBox`)),
                productTypes: formatValidation(t('validation.statusCode.code.1'), t(`item.autoFill.productTypesCheckBox`)),
            },
        };
        let valueValidate = {
            minLength: {
                // autoFillApplyConfig: 1,
                memberShipTypes: 1,
                productTypes: 1,
            },
        };

        let autoFillDayOfWeek = null;
        if(autoFillApplyConfig){
            autoFillDayOfWeek = parseDayOfWeek(autoFillApplyConfig);
        }

        let result = multipleValidate({...autoFill, autoFillApplyConfig: autoFillDayOfWeek.length > 0 ? autoFillDayOfWeek : null }, validate, valueValidate);
        setValidation(result);
        return Object.keys(result).length < 1;
    }

    const parseDayOfWeek = (data)=> {
        let result = [];
        if (data && Object.keys(data).length > 0) {
            (moment.localeData('en').weekdays() || []).map((day, index) => {
                const dayKey = day.toLowerCase();
                if (dayKey && data[dayKey]) {
                    result.push(index);
                }
            })
        }
        return result ? result.sort() : result;
    }

    const onClickBack = () => {
        props.history.push(PATHS.AUTOFILL.LIST.path);
    }

    const isDisableSubmit = () => {
        return (action === DETAIL_ACTIONS.CREATE && !permissionActions.allowCreate)
            || (action === DETAIL_ACTIONS.UPDATE && !permissionActions.allowUpdate)
    }

    const selectFilterSearch = (input, option) => {
        const optionText = vietnameseStringToUnicode(option?.props?.children?.props?.children.toLowerCase());
        const inputText = vietnameseStringToUnicode(input.toLowerCase());
        return optionText.indexOf(inputText) >= 0;
    }

    const onChangeValue = (name, value) => {
        if(name === 'campaignId'){
            loadDataPromotion({campaignId: value})
            onChangeDetail('promotionCodeId', null);
            let objCampaign = campaignsValue.find(item => item.id === value);
            if(objCampaign){
                setAllowCreateAutoFill(true);
            }
            setCampaign(objCampaign);
        }
        onChangeDetail(name, value);
    }

    const onChangeDetail = (name, value) => {
        const oldAutoFill = autoFill;
        oldAutoFill[name] = value;
        setAutoFill({ ...oldAutoFill });
    }

    const onSelectScheduleDate = (data) => {
        const startDate = cloneDeep(data.fullValue[0])
        const endDate = cloneDeep(data.fullValue[1])
        onChangeDetail('startDate', startDate);
        onChangeDetail('endDate', endDate);
    }

    const getMemberShipTypeEnums = ()=> {
        return toArray(AUTOFILL_ENUM.MEMBER_SHIP_TYPE);
    }

    const getProducTypeEnums = ()=>{
        return toArray(AUTOFILL_ENUM.PRODUCTYPES);
    }

    const getProducTypeGroupbyEnums = (key)=>{
        return toArray(AUTOFILL_ENUM.PRODUCTYPES_GROUPBY[key]);
    }

    const getAutoFillPlatformLabel = (platform) => {
        return `${platform.platform} - ${platform.feature}`;
    }

    const getAutoFillPlatformsGroupByArea = () => {
        return normalizeAutoFillPlatforms(autoFill.platforms).reduce((result, platform) => {
            const area = platform.area;
            result[area] = result[area] || [];
            result[area].push(platform);
            return result;
        }, {});
    }

    const onChangePlatform = platform => e => {
        const platformKey = getAutoFillPlatformKey(platform);
        const platforms = normalizeAutoFillPlatforms(autoFill.platforms).map(item => {
            if (getAutoFillPlatformKey(item) === platformKey) {
                return {
                    ...item,
                    isEnabled: e.target.checked
                }
            }
            return item;
        });
        onChangeDetail('platforms', platforms);
    }

    const onChangeCheckBoxGroup = name => list =>{
        if(list){
            let memberShipTypeGuest = autoFill['memberShipTypes'].filter(item => item === 4 || item === 'GUEST');
            if(name === 'memberShipTypes'){
                list = [...memberShipTypeGuest, ...list];
            }
            onChangeDetail([name], list);
        }
    }

    const onChangeCheckBox = name => e =>{
        let memberShipTypeOld = autoFill['memberShipTypes'];
        if(name === 'memberShipTypes'){
            if(e.target.checked){
                memberShipTypeOld = [...memberShipTypeOld, 4];
            }else{
                memberShipTypeOld = memberShipTypeOld.filter(item => item !== 4 && item !== 'GUEST');
            }
        }
        onChangeDetail([name], memberShipTypeOld);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        if (validate()) {
            if(Object.keys(autoFill).length > 0){
                const request = {
                    ...autoFill,
                    dayOfWeek: autoFillApplyConfig,
                }
                if (action === DETAIL_ACTIONS.CREATE) {
                    createAutoFill(request)
                } else {
                    updateAutoFill(request)
                }
            }
        }
    }

    const disabledDate = (current) => {
        if(Object.keys(campaign).length > 0){
            return current < moment(new Date(campaign.startTime)).startOf('day')
             || current > moment(new Date(campaign.endTime)).startOf('day').add(1, 'day');
        }
        return current < moment().startOf('day');
    }

    const onChangeAutoFillConfigDetail = (dayKey, currentValue)=>{
        const oldAutoFillApplyConfig = autoFillApplyConfig;
        oldAutoFillApplyConfig[dayKey] = currentValue;
        setAutoFillApplyConfig({ ...oldAutoFillApplyConfig });
    }

    return (
        <LoadingComponent spinning={ isFetchingAutoFill }>
            <PageListComponent className="autofill-detail-page">
                <HeaderListComponent
                    path={ match.path }
                    groupPath={ 'autoFill' }
                    titleHeader={ getTitleHeader() }
                    componentRight={ null }
                />
                <FormActionComponent
                    onSubmit={ onSubmit }
                    isSubmit={ isSubmit }
                    action={ action }
                    isGetItem={ isGetItem }
                    onClickBack={ onClickBack }
                    submitButtonRight={ true }
                    disableButtonSubmit={ isDisableSubmit() }
                >
                    <FormWrapperItem>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={ 'right' }
                                isValidation={ true }
                                validation={ validation.campaignId }
                                messageBelowInput={ true }
                                labelTitle={ t(`item.autoFill.campaign`) }
                            >
                                <AntSelect className="select-types"
                                    showArrow showSearch
                                    placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.autoFill.campaign")).toLowerCase()) }
                                    onChange={ (e) => onChangeValue('campaignId', e) }
                                    style={ { width: '100%' } }
                                    value={ action === DETAIL_ACTIONS.UPDATE ? autoFill.campaignName : autoFill.campaignId }
                                    loading={ isFetchingCampaign }
                                    disabled={action === DETAIL_ACTIONS.UPDATE}
                                    filterOption={ (inputValue, option) => selectFilterSearch(inputValue, option) }
                                >
                                    { (campaignsValue || []).map(campaign => (
                                        <AntOption key={ campaign.id } value={ campaign.id }>
                                            <Tooltip title={ campaign.name } placement="topLeft">{ `${ campaign.code } - ${ campaign.name }` }</Tooltip>
                                        </AntOption>
                                    )) }
                                </AntSelect>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                dataValidation={ autoFill.startDate }
                                validation={ validation.startDate }
                                labelTitle={ t(`item.autoFill.schedules`) }
                            >
                                <DatePickerComponent className={ classNames("form-control applyDates w100-percent", {
                                    'border-red': !!validation.startDate
                                }) }
                                    disabled={ !allowCreateAutoFill }
                                    disabledDate={ disabledDate }
                                    hmsComponent={ `RangePicker` } format={ DATE_TIME_FORMAT.DATE_TIME }
                                    showTime={ { format: DATE_TIME_FORMAT.SHORT_TIME } }
                                    style={ { padding: 0, borderWidth: validation.schedules ? 1 : 0 } }
                                    onChange={ onSelectScheduleDate } name={ `applyDates` }
                                    placeholder={ [t('placeHolderForm.startDate'), t('placeHolderForm.endDate')] }
                                    value={ [autoFill.startDate, autoFill.endDate] }
                                />
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                validation={ validation.promotionCodeId }
                                messageBelowInput={ true }
                                labelTitle={ t(`item.autoFill.promotionCodeId`) }
                            >
                                <AntSelect className="select-departure"
                                    showArrow showSearch
                                    disabled={ !allowCreateAutoFill }
                                    placeholder={ capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.autoFill.promotionCode")).toLowerCase()) }
                                    onChange={ (e) => onChangeValue('promotionCodeId', e) }
                                    style={ { width: '100%' } }
                                    value={ autoFill.promotionCodeId }
                                    loading={ isFetching }
                                    filterOption={ (inputValue, option) => selectFilterSearch(inputValue, option) }
                                >
                                    { (promotionsValue || []).map(promotion => (
                                        <AntOption key={ promotion.promotionId } value={ promotion.promotionId }>
                                            <Tooltip title={ promotion.promotionCode } placement="topLeft">{ promotion.promotionCode }</Tooltip>
                                        </AntOption>
                                    )) }
                                </AntSelect>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                    isRequired={ true }
                                    labelTitle={ t(`item.autoFill.dayOfWeek`) }
                                    isValidation={ true }
                                    validation={ validation.autoFillApplyConfig }
                                    messageBelowInput={ true }
                                >
                                    <div className={ `ant-btn-group applyDays ${ validation.autoFillApplyConfig && validation.autoFillApplyConfig.classError ? `error-bundle-apply-config` : `` }` }>
                                        { (moment.localeData('en').weekdays() || []).map(day => {
                                            const dayKey = day.toLowerCase();
                                            return <Span key={ dayKey }
                                                         className={ `ant-btn ant-btn-${ autoFillApplyConfig[dayKey] ? 'primary' : 'default' }` }
                                                         onClick={ e => onChangeAutoFillConfigDetail(dayKey, !autoFillApplyConfig[dayKey]) }
                                            >{ t(`item.ticket.${ dayKey }`) }</Span>
                                        }) }
                                    </div>
                                </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-6">
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                validation={ validation.memberShipTypes }
                                messageBelowInput={ true }
                                labelTitle={ t(`item.autoFill.memberShipTypeCheckBox`) }
                            >
                                <div>
                                    <Checkbox
                                        checked={autoFill.memberShipTypes.includes('GUEST') || autoFill.memberShipTypes.includes(4)}
                                        onChange={onChangeCheckBox('memberShipTypes')}
                                        disabled={ !allowCreateAutoFill }
                                    >
                                        Guest &nbsp;
                                        <Tooltip title={ 'Hạng guest dành cho khách vãng lai không đăng nhập, nếu check hạng guest mà không check thêm các hạng khác thì khi đăng nhập sẽ không được autofill' } >
                                            <Icon type="info-circle" />
                                        </Tooltip>
                                    </Checkbox><br/>
                                    <CheckboxGroup
                                        className="m-t"
                                        disabled={ !allowCreateAutoFill }
                                        options={ getMemberShipTypeEnums()?.filter(item => item.id !== 4) }
                                        value={ autoFill.memberShipTypes.length > 0 ?
                                            autoFill.memberShipTypes.map((item)=>
                                                typeof item === 'string' ? AUTOFILL_ENUM?.MEMBER_SHIP_TYPE[item]?.value : item
                                            ) : []}
                                        onChange={ onChangeCheckBoxGroup('memberShipTypes') }
                                    />
                                </div>

                            </FormWrapperInputComponent>
                        </Wrapper>

                        <Wrapper className="col-md-6 autofill-checkbox">
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                validation={ validation.productTypes }
                                messageBelowInput={ true }
                                labelTitle={ t(`item.autoFill.productTypesCheckBox`) }
                            >
                                <div>
                                    <CheckboxGroup
                                        className="m-t"
                                        disabled={ !allowCreateAutoFill }
                                        // options={ getProducTypeGroupbyEnums('BOOKING_VP') }
                                        value={autoFill.productTypes.length > 0 ?
                                            autoFill.productTypes.map((item)=>{
                                                return typeof item === 'string' ? AUTOFILL_ENUM.PRODUCTYPES[item]?.value : item
                                            }) : []
                                        }
                                        onChange={ onChangeCheckBoxGroup('productTypes') }
                                    >
                                        <div className="checkbox-items booking-vp">
                                            <span className="items-label">Booking.vinpearl.com</span>
                                            <div className="items">
                                                {
                                                    getProducTypeGroupbyEnums('BOOKING_VP').map((item) => {
                                                        return <Checkbox key={ item.key } value={ item.value }>{ item.label }</Checkbox>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="checkbox-items app-myvp">
                                            <span className="items-label">App MyVP</span>
                                            <div className="items">
                                                {
                                                    getProducTypeGroupbyEnums('APP_MYVP').map((item) => {
                                                        return <Checkbox key={ item.key } value={ item.value }>{ item.label }</Checkbox>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="checkbox-items app-vw">
                                            <span className="items-label">App vinwonder</span>
                                            <div className="items">
                                                {
                                                    getProducTypeGroupbyEnums('APP_VW').map((item) => {
                                                        return <Checkbox key={ item.key } value={ item.value }>{ item.label }</Checkbox>
                                                    })
                                                }
                                            </div>
                                        </div>
                                        <div className="checkbox-items booking-vw">
                                            <span className="items-label">Booking.vinwonder.com</span>
                                            <div className="items">
                                                {
                                                    getProducTypeGroupbyEnums('BOOKING_VW').map((item) => {
                                                        return <Checkbox key={ item.key } value={ item.value }>{ item.label }</Checkbox>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </CheckboxGroup>
                                </div>

                                {/* <div>
                                    <CheckboxGroup
                                        className="m-t"
                                        disabled={ !allowCreateAutoFill }
                                        options={ getProducTypeEnums() }
                                        value={autoFill.productTypes.length > 0 ?
                                            autoFill.productTypes.map((item)=>{
                                                return typeof item === 'string' ? AUTOFILL_ENUM.PRODUCTYPES[item]?.value : item
                                            }) : []
                                        }
                                        onChange={ onChangeCheckBoxGroup('productTypes') }
                                    />
                                </div> */}

                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className='col-md-6'>
                            <FormWrapperInputComponent
                                isRequired={ true }
                                isValidation={ true }
                                dataValidation={ autoFill.order }
                                validation={ validation.order }
                                labelTitle={ t(`item.autoFill.order`) }
                            >
                                <Input type="text"
                                    disabled={ !allowCreateAutoFill }
                                    autoComplete="off"
                                    placeholder={ capitalizeFirstLetter((t('placeHolderForm.input') + " " + t("item.autoFill.order")).toLowerCase()) }
                                    className="form-control" name="order" onChange={ (e) => onChangeValue('order', e.target.value) }
                                    value={ autoFill.order ? autoFill.order : "" }/>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className="col-md-12 autofill-platform-checkbox">
                            <FormWrapperInputComponent
                                labelTitle={ t(`item.autoFill.platformsCheckBox`) }
                            >
                                <div className="platform-items">
                                    { Object.entries(getAutoFillPlatformsGroupByArea()).map(([area, platforms]) => (
                                        <div className="platform-area" key={ area }>
                                            <span className="items-label">{ area }</span>
                                            <div className="items">
                                                { platforms.map(platform => (
                                                    <Checkbox
                                                        key={ getAutoFillPlatformKey(platform) }
                                                        checked={ platform.isEnabled }
                                                        onChange={ onChangePlatform(platform) }
                                                        disabled={ !allowCreateAutoFill }
                                                    >
                                                        { getAutoFillPlatformLabel(platform) }
                                                    </Checkbox>
                                                )) }
                                            </div>
                                        </div>
                                    )) }
                                </div>
                            </FormWrapperInputComponent>
                        </Wrapper>
                        <Wrapper className='col-md-6'>
                            <div className="form-group">
                                <label className="fs15">{t(`item.autoFill.isActive`)} - {autoFill.isActive ? <span style={{color: 'green'}}>Hoạt động</span> : <span style={{color: 'red'}}>Không hoạt động</span>}</label><br />
                                <Switch checked={autoFill.isActive} onChange={(value, e) => onChangeValue('isActive', value)} name={`isActve`} disabled={false}/>
                            </div>
                        </Wrapper>
                    </FormWrapperItem>
                </FormActionComponent>
            </PageListComponent>
        </LoadingComponent>
    )
}

export default withTranslation()(AutoFillDetail);
